import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import InputCom from '../Helpers/InputCom';
import { useAppDispatch } from '../../hooks/hooks';
import { showAlert } from '../../store/alertsReducer';
import spinWheelAPI from '../../API/spinWheelAPI';

export const SendEmailForm = ({ coupon }: { coupon: string }) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const sendEmail = () => {
    setIsLoading(true);
    spinWheelAPI
      .sendEmail(email, coupon)
      .then((res) => {
        dispatch(showAlert({ alerts: res.message, successType: true }));
        setEmail('');
      })
      .catch((err) => {
        setError(err.response.data.message);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const handleSubmit = (e: any) => {
    e.preventDefault();
    sendEmail();
  };

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setEmail(e.target.value);
    if (error) {
      setError('');
    }
  };

  return (
    <div className='mt-10 border-t border-line pt-8'>
      <h3 className='display-sm mb-4'>Send the coupon to your email</h3>

      <form
        onSubmit={handleSubmit}
        className='mx-auto flex max-w-[440px] flex-col gap-3 sm:flex-row'
      >
        <div className='flex-1 text-left'>
          <InputCom
            label=''
            placeholder={`${t('email')}`}
            name='email'
            type='email'
            required
            value={email}
            inputHandler={onChange}
            errorMessage={error}
          />
        </div>

        <button type='submit' className='btn btn-ink flex-none' disabled={isLoading}>
          Activate
        </button>
      </form>
    </div>
  );
};
